<main class="home">
  <app-welcome></app-welcome>

  <div class="home-container container">
    <article class="home-info">
      <div class="home-info__content"
           [innerHTML]="homePageData?.article"></div>
    </article>

    <aside class="home-aside">
      <div class="home-aside__group">
        @for (card of homePageData?.cards; track card) {
        <div class="home-card">
          <img class="home-card__photo"
               [attr.data-src]="card.photo"

               alt="photo">
          <div class="home-card__detail">
            <span class="home-card__text">{{card.name}}</span>
            <span class="home-card__text">{{card.position}}</span>
            <span class="home-card__text">{{card.company}}</span>
          </div>
          <img class="home-card__signature"
               [attr.data-src]="card.signature"
               alt="signature">
        </div>
        }
      </div>

      @if (homePageData?.video) {
      <app-video [poster]="homePageData?.video.poster"
                 [src]="homePageData?.video.src"
                 class="home-aside__video"></app-video>
      }
    </aside>
  </div>
</main>
